import { ROUTE_PATHS } from "../../../../constants/app.constants";
import ReportPreviewSharePage from "../../../sec-stack-report/report-preview-share-page";
import styles from "./index.module.scss";
import { useParams } from "react-router-dom";
import { useMemo } from "react";

const MspReportPreview = () => {
  const { accountId } = useParams();
  const backPath = useMemo(() => ROUTE_PATHS.subscriptionPortalPages.mspStackReport(accountId), [accountId]);

  return (
    <div className={styles.container}>
      <ReportPreviewSharePage backPath={backPath} />
    </div>
  )
}

export default MspReportPreview;
